import { Box, Typography } from "@mui/material";
import { ISpiffSetupRule, ITiers } from "../../../../types/spiffSetup";
import EligibilityTiers from "../EligibilityTiers";
import { isYear } from "../../../../helpers/SpiffRuleValidator";

const resolveYear = (year: string) => {
	if (!year) {
		return "";
	}

	if (isYear(year)) {
		return year;
	}

	const yearText = parseInt(year, 10) === 1 || parseInt(year, 10) === -1 ? "Year" : "Years";
	return year === "0" ? "Current" : `Current ${year} ${yearText}`;
};

interface SalesContentProps {
	rules: ISpiffSetupRule[];
	tiers: ITiers[];
	tiersHeaderTitle: string;
	verticalText: string;
	commissionColumnsTitle: string;
	informationMessage: string[];
	franchises: string[];
	spiffType: string;
}

const SalesContent = (props: SalesContentProps) => {
	const { rules, tiers, tiersHeaderTitle, verticalText, commissionColumnsTitle, informationMessage, franchises, spiffType } = props;
	return (
		<>
			{rules.map((rule) => {
				const years =
					rule.startYear && rule.endYear
						? `${resolveYear(rule.startYear)} to ${resolveYear(rule.endYear)}`
						: resolveYear(rule.startYear) || resolveYear(rule.endYear);
				const ruleText = [rule.make, rule.model, rule.trim, rule.status, years, rule.stockExpression].filter(Boolean).join(" ");

				return (
					<Box key={rule._id} className="flex flex-row">
						<Typography className="!font-montserrat !font-medium !text-lg text-gray-text">{ruleText}</Typography>
					</Box>
				);
			})}

			{tiers && tiers.length > 0 && (
				<EligibilityTiers
					franchises={franchises}
					tiers={tiers}
					tiersHeaderTitle={tiersHeaderTitle}
					informationMessage={informationMessage}
					verticalText={verticalText}
					commissionColumnsTitle={commissionColumnsTitle}
					spiffType={spiffType}
				/>
			)}
		</>
	);
};

export default SalesContent;
